var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"base-btn flex justify-center flex-row items-center",class:`${_vm.outlined ? 'outline-btn' : 'normal-btn'}`,style:(`---color: ${_vm.color}; ---background-color: ${_vm.background}; ---color-hover: ${
      _vm.dark ? '#fff' : _vm.background
    };`),on:{"click":_vm.clickEvent}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }